/* eslint-disable @typescript-eslint/no-explicit-any */
import { clinicasApi } from '../../../common/services/apis/clinicasApi.ts';
import { tokenApi } from '../../../common/services/apis/tokenApi.ts';
import { loadClinicas, setClinicas } from '../slices/clinicasSlices.ts';

export const getClinicas = () => {
    return async (dispatch: any) => {
        dispatch(loadClinicas());
        let token = await tokenApi.then((tokenresultado) => tokenresultado);
        const desToken = token.data.split(',');
        const numeroToken=desToken[1].split('=');

        const { data } = await clinicasApi(numeroToken[1]).get(``);
      
         dispatch(setClinicas({ clinicas: (data)  }));

    }
}